import PropTypes from 'prop-types';
import { screen } from 'components/styles/variables';

export default function GridRow({ children }) {
  return (
    <div className="dealer-page-grid-row">
      {children}
      <style jsx>{`
        @media (min-width: ${screen.smMin}) {
          .dealer-page-grid-row {
            padding: 0 30px;
          }
        }

        @media (min-width: ${screen.lgMin}) {
          .dealer-page-grid-row {
            padding: 0 110px;
          }
        }
      `}</style>
    </div>
  );
}

GridRow.propTypes = {
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
    .isRequired,
};
